// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__SZ3Mb","header":"MessagesList_header__eIpLQ","chat":"MessagesList_chat__WGSg6"};